import { PublicProfileScreen } from '@/components/profile/public-profile-screen';
import { TeamMemberProfileScreen } from '@/components/profile/team-member-profile-screen';
import { useMembership } from '@/hooks/use-membership';
import { useActingProviderStore } from '@/store/actingProviderStore';

export default function PublicProfilePage() {
  // Numa equipe, a vitrine é do negócio: o profissional cuida do perfil dele
  // dentro dela, não de uma página própria. Com um profissional em foco o dono
  // vê esse mesmo perfil — a marca da organização continua na tela dele, sem
  // foco.
  const { can } = useMembership();
  const isActing = useActingProviderStore((s) => !!s.acting);
  return can('orgBranding') && !isActing ? <PublicProfileScreen /> : <TeamMemberProfileScreen />;
}
